import React from 'react';
import PropTypes from 'proptypes';
import { FieldGroup, FieldControl } from 'react-reactive-form';

const TermsAndConditionsModal = ({
  closeModal,
  destination,
  startDate,
  endDate,
  handleRegistrationSubmit,
  registrationForm,
}) => (
  <div>
    <div className="row">
      <button className="square-icon right" onClick={closeModal}>
        X
      </button>
    </div>
    <div>
      <div id="registrationContentHeader" className="center">
        <h1>Registration Form</h1>
        <p>
          Growth International Volunteer Excursions LLC (GIVE)
          <br />
          1900 W Nickerson St, Suite 116 #123, Seattle, WA 98119
          <br />
          www.givevolunteers.org ∙ (206) 973-7991
          <br />
        </p>
        <p>
          <b>
            This is a legally binding document. Please read and complete this agreement carefully,
            sign, and submit.
          </b>
        </p>
        <h4 className="center">
          {destination} {startDate} - {endDate}
          <br />
        </h4>
        <h5>and including any additional add-ons and/or extentions</h5>
      </div>

      <FieldGroup
        control={registrationForm}
        render={({ value, submitted }) => (
          <div className="justify-content-center">
            <form
              id="terms-and-conditions-form"
              name="registration"
              onSubmit={e => {
                e.preventDefault();
                if (registrationForm.status === 'VALID') {
                  handleRegistrationSubmit(
                    e,
                    registrationForm.value,
                    document.getElementById('registrationContentHeader').innerHTML,
                    document.getElementById('medicalInformationHeader').innerHTML,
                    document.getElementById('dietaryRequirementsContent').innerHTML,
                    document.getElementById('allergiesContent').innerHTML,
                    document.getElementById('medicalConditionsContent').innerHTML,
                    document.getElementById('mentalHealthConditionsContent').innerHTML,
                    document.getElementById('neurodivergentConditionsContent').innerHTML,
                    document.getElementById('mentalHealthTreatmentContent').innerHTML,
                    document.getElementById('mentalHealthHospitalizationContent').innerHTML,
                    document.getElementById('medicalNotesContent').innerHTML,
                    document.getElementById('medicationsContent').innerHTML,
                    document.getElementById('medicationConsistencyContent').innerHTML,
                    document.getElementById('eventOfEmergencyContent').innerHTML,
                    document.getElementById('registrationContent').innerHTML
                  );
                  document.getElementById('form-error-message').classList.add('hidden');
                  document.getElementById('submit-loading').classList.add('loader');
                } else {
                  document.getElementById('submit-loading').classList.remove('loader');
                  document.getElementById('form-error-message').classList.remove('hidden');
                }
              }}
              autoComplete="off"
            >
              <div id="medicalInformationHeader">
                <h3 className="left">Medical Information</h3>
                <p>
                  As part of our commitment to providing a safe and supportive experience for you
                  and all travelers, please provide your physical and mental health conditions,
                  medications, and any information that may affect your participation during the
                  trip. Travel can increase anxiety or trigger conditions, so it is essential that
                  you truthfully complete this form so we can support you. Your honesty in providing
                  accurate information is crucial, and this form is confidential. Thank you for your
                  cooperation.
                </p>
                <br />
              </div>

              <div>
                <p id="dietaryRequirementsContent">
                  Do you have any dietary restrictions, intolerance, or food allergies?
                </p>
                <FieldControl
                  name="dietaryRequirements"
                  render={({ handler, touched, hasError, pristine }) => (
                    <div className="inputContainer">
                      <textarea className="form-control input-fix" type="text" {...handler()} />
                      <label
                        htmlFor="dietaryRequirements"
                        className={`label ${
                          pristine && !registrationForm.controls.dietaryRequirements.value
                            ? ''
                            : 'notEmpty'
                        }`}
                      >
                        Dietary Requirements
                        <span className="error">{hasError('required') && ' - Required'}</span>
                      </label>
                    </div>
                  )}
                />
              </div>

              <div>
                <p id="allergiesContent">
                  Do you have any allergies (medication, latex, environmental, food, etc)? If yes,
                  please list all allergies, symptoms, and medications.
                </p>
                <FieldControl
                  name="allergies"
                  render={({ handler, touched, hasError, pristine }) => (
                    <div className="inputContainer">
                      <textarea className="form-control input-fix" type="text" {...handler()} />
                      <label
                        htmlFor="allergies"
                        className={`label ${
                          pristine && !registrationForm.controls.allergies.value ? '' : 'notEmpty'
                        }`}
                      >
                        Allergies
                        <span className="error">{hasError('required') && ' - Required'}</span>
                      </label>
                    </div>
                  )}
                />
              </div>

              <div>
                <p id="medicalConditionsContent">
                  Do you have any pre-existing medical conditions, physical health considerations,
                  mobility restrictions, or conditions that flare with sun exposure? This may
                  include, but is not limited to epilepsy, lupus, chronic conditions, recent
                  surgeries and injuries, or any other factors that could affect your participation.
                  Please Include any medical history that may affect your participation.
                </p>
                <FieldControl
                  name="medicalConditions"
                  render={({ handler, touched, hasError, pristine }) => (
                    <div className="inputContainer">
                      <textarea className="form-control input-fix" type="text" {...handler()} />
                      <label
                        htmlFor="medicalConditions"
                        className={`label ${
                          pristine && !registrationForm.controls.medicalConditions.value
                            ? ''
                            : 'notEmpty'
                        }`}
                      >
                        Medical Conditions
                        <span className="error">{hasError('required') && ' - Required'}</span>
                      </label>
                    </div>
                  )}
                />
              </div>

              <div>
                <p id="mentalHealthConditionsContent">
                  Have you ever been diagnosed with a mental health condition or emotional disorder?
                  This includes but is not limited to anxiety disorders (generalized anxiety,
                  phobias, PTSD, panic disorder, obsessive-compulsive disorder), mood disorders
                  (depression, self-harm, bipolar disorder), psychotic disorders (schizophrenia),
                  personality disorder (borderline personality disorder), eating disorder, or other
                  mood disorders? If yes, please list the diagnosis, diagnosis date, medication(s)
                  and dosage, and provide further details on how you cope with this in your own
                  personal life.
                </p>
                <FieldControl
                  name="mentalHealthConditions"
                  render={({ handler, touched, hasError, pristine }) => (
                    <div className="inputContainer">
                      <textarea className="form-control input-fix" type="text" {...handler()} />
                      <label
                        htmlFor="mentalHealthConditions"
                        className={`label ${
                          pristine && !registrationForm.controls.mentalHealthConditions.value
                            ? ''
                            : 'notEmpty'
                        }`}
                      >
                        {' '}
                        <span className="error">{hasError('required') && 'Required'}</span>
                      </label>
                    </div>
                  )}
                />
              </div>

              <div>
                <p id="neurodivergentConditionsContent">
                  Do you have any specific conditions, neurodivergent or otherwise? This could
                  include but is not limited to autism, ADHD, sensory sensitivities, or any other
                  considerations that might impact your experience.
                </p>
                <FieldControl
                  name="neurodivergentConditions"
                  render={({ handler, touched, hasError, pristine }) => (
                    <div className="inputContainer">
                      <textarea className="form-control input-fix" type="text" {...handler()} />
                      <label
                        htmlFor="neurodivergentConditions"
                        className={`label ${
                          pristine && !registrationForm.controls.neurodivergentConditions.value
                            ? ''
                            : 'notEmpty'
                        }`}
                      >
                        {' '}
                        <span className="error">{hasError('required') && 'Required'}</span>
                      </label>
                    </div>
                  )}
                />
              </div>

              <div>
                <p id="mentalHealthTreatmentContent">
                  Are you currently receiving, or have you received in the past two years,
                  counseling or treatment for any emotional condition, drug addition, alcoholism,
                  psychiatric condition, or eating disorder? If yes, please describe and include
                  when the incident(s) occurred.
                </p>
                <FieldControl
                  name="mentalHealthTreatment"
                  render={({ handler, touched, hasError, pristine }) => (
                    <div className="inputContainer">
                      <textarea className="form-control input-fix" type="text" {...handler()} />
                      <label
                        htmlFor="mentalHealthTreatment"
                        className={`label ${
                          pristine && !registrationForm.controls.mentalHealthTreatment.value
                            ? ''
                            : 'notEmpty'
                        }`}
                      >
                        {' '}
                        <span className="error">{hasError('required') && 'Required'}</span>
                      </label>
                    </div>
                  )}
                />
              </div>

              <div>
                <p id="mentalHealthHospitalizationContent">
                  Have you ever been hospitalized or institutionalized for a mental health episode
                  or experienced challenges related to suicide or self-harm? If yes, please describe
                  and include when the incident(s) occurred.
                </p>
                <FieldControl
                  name="mentalHealthHospitalization"
                  render={({ handler, touched, hasError, pristine }) => (
                    <div className="inputContainer">
                      <textarea className="form-control input-fix" type="text" {...handler()} />
                      <label
                        htmlFor="mentalHealthHospitalization"
                        className={`label ${
                          pristine && !registrationForm.controls.mentalHealthHospitalization.value
                            ? ''
                            : 'notEmpty'
                        }`}
                      >
                        {' '}
                        <span className="error">{hasError('required') && 'Required'}</span>
                      </label>
                    </div>
                  )}
                />
              </div>

              <div>
                <p id="medicalNotesContent">
                  Please include any additional information that may deem pertinent to your
                  participation. This can include any medical and mental health notes, specific
                  phobias, fears, triggers, or concerns that you may encounter during your trip.
                </p>

                <FieldControl
                  name="medicalNotes"
                  render={({ handler, touched, hasError, pristine }) => (
                    <div className="inputContainer">
                      <textarea
                        id="medicalNotes"
                        className="form-control input-fix"
                        type="text"
                        {...handler()}
                      />
                      <label
                        htmlFor="medicalNotes"
                        className={`label ${
                          pristine && !registrationForm.controls.medicalNotes.value
                            ? ''
                            : 'notEmpty'
                        }`}
                      >
                        <span className="error">{hasError('required') && 'Required'}</span>
                      </label>
                    </div>
                  )}
                />
              </div>

              <div>
                <p id="medicationsContent">
                  Please list all current medications (even if included above), prescribed or
                  over-the-counter, the associated condition/reason for taking them, start date,
                  dosage, and frequency.{' '}
                  <i>
                    You are responsible for providing and self-administering any medications while
                    on the trip. Travel can trigger or exacerbate physical and mental health
                    conditions and it is critical that you take medications as prescribed. Do not
                    alter your prescribed medications, dosage, and regimen, or stop medications
                    before or during the trip. If you currently plan on stopping or changing any
                    medication in which you normally take, please include the end date and reason(s)
                    why.
                  </i>
                </p>
                <FieldControl
                  name="medications"
                  render={({ handler, touched, hasError, pristine }) => (
                    <div className="inputContainer">
                      <textarea className="form-control input-fix" type="text" {...handler()} />
                      <label
                        htmlFor="medications"
                        className={`label ${
                          pristine && !registrationForm.controls.medications.value ? '' : 'notEmpty'
                        }`}
                      >
                        Medications
                        <span className="error">{hasError('required') && ' - Required'}</span>
                      </label>
                    </div>
                  )}
                />
              </div>

              <div>
                <p id="medicationConsistencyContent">
                  Do you ever forget or choose not to take your medication? Would you like
                  medication reminders during your trip?
                </p>
                <FieldControl
                  name="medicationConsistency"
                  render={({ handler, touched, hasError, pristine }) => (
                    <div className="inputContainer">
                      <textarea className="form-control input-fix" type="text" {...handler()} />
                      <label
                        htmlFor="medicationConsistency"
                        className={`label ${
                          pristine && !registrationForm.controls.medicationConsistency.value
                            ? ''
                            : 'notEmpty'
                        }`}
                      >
                        {' '}
                        <span className="error">{hasError('required') && 'Required'}</span>
                      </label>
                    </div>
                  )}
                />
              </div>

              <div>
                <p id="eventOfEmergencyContent">
                  In the event of an emergency where you are unable to make decisions regarding your
                  health care and safety, effective at trip commencement and ending at trip's end,
                  as defined below, you agree to allow GIVE to treat you and to make further health
                  care and evacuation decisions for you if necessary.
                </p>
                <div className="col-md-3 col-sm-6 center">
                  <FieldControl
                    name="initials"
                    render={({ handler, touched, hasError, pristine }) => (
                      <div className="inputContainer center">
                        <input id="initials" className="form-control" type="text" {...handler()} />
                        <label
                          htmlFor="initials"
                          className={`label ${
                            pristine && !registrationForm.controls.initials.value ? '' : 'notEmpty'
                          }`}
                        >
                          Initials
                          <span className="error">{hasError('required') && ' - Required'}</span>
                        </label>
                      </div>
                    )}
                  />
                </div>
              </div>

              <br />
              <br />
              <br />

              <div id="registrationContent">
                <h3>Travelers & Health Insurance</h3>
                <p>
                  You are required to have health insurance to participate in our trips due to the
                  nature of the activities and environment involved, and the possibility of injury
                  or illness. As medical facilities may not always be readily accessible, we
                  recommend your medical insurance include coverage for evacuation as well as
                  international incidents for trips abroad. By signing this form you acknowledge and
                  agree that you, and not GIVE, are solely responsible for any medical and
                  evacuation expenses or costs incurred in the event of injury or illness as a
                  result of your trip participation.
                </p>
                <p>
                  You are required to have travelers insurance that includes coverage for trip
                  cancellation, interruption/curtailment, and medical insurance to participate in
                  our trips due to the unexpected nature of traveling. Travelers insurance provides
                  coverage for flight and trip delays, cancellations, and interruptions, and lost,
                  stolen, or delayed baggage. By signing this form you acknowledge and agree that
                  you, and not GIVE, are solely responsible for any travel associated expenses,
                  costs, delays, or cancellations.
                </p>
                <p>
                  You agree to provide GIVE with proof of travelers insurance with health insurance
                  coverage that meets our minimum requirements by the your trip document deadline.
                </p>

                <h3>Deposit, Payment, and Refund Policy</h3>
                <p>
                  (1) You are required to pay a minimum of the nonrefundable, nontransferable
                  deposit to GIVE with your Program Agreement in order to reserve your space on the
                  trip. Subject to availability, your reservation date is the date of GIVE's receipt
                  of the deposit and Program Agreement.
                </p>
                <p>
                  (2) Deposits and payments for activities before trip commencement and after trip
                  end or early departure, as defined below, and those provided by third party
                  vendors, are not the responsibility of GIVE and will therefore not be refunded by
                  GIVE.
                </p>
                <p>
                  (3) You are required to pay your entire remaining program balance at least 80 days
                  prior to the trip departure date. You will be charged a $50.00 late fee for late
                  payments. If GIVE does not receive full payment at least 80 days prior to trip
                  departure and no prior arrangements have been made with GIVE, you will have
                  assumed to have cancelled your trip participation and your reservation may be
                  given to another. Although considered cancelled, GIVE may reinstate your
                  reservation on the trip upon notice from you, full payment, and space
                  availability. There will be a $150 fee associated with reinstating your trip or
                  deducted from the remaining balance of the cancelled trip.
                </p>
                <p>
                  (4) Trip cancellations must be given to GIVE in writing via email with
                  confirmation of receipt by GIVE. No verbal cancellations will be accepted.
                  Payments cannot be transferred to another GIVE program or participant. Upon GIVE's
                  receipt of written cancellation, you are liable for the cancellation charges as
                  defined below, based on your Payment Option selection (see below):
                </p>

                <h4>PAYMENT OPTIONS</h4>
                <p>
                  When registering for a GIVE Program, participants may choose from the following
                  payment structures:
                </p>

                <p>
                  1. <b>Pay in Full</b>
                </p>
                <ul className="default">
                  <li>
                    Participants who pay their full program balance at the time of registration may
                    receive a discount off the total program cost.
                  </li>
                  <li>
                    <b>
                      All payments made under this plan are non-refundable and valid only as
                      lifetime travel credit.
                    </b>
                  </li>
                </ul>

                <p>
                  2. <b>Buy Now, Pay Later (BNPL)</b>
                </p>
                <ul className="default">
                  <li>
                    GIVE may offer BNPL options via third-party providers or internal installment
                    plans.
                  </li>
                  <li>
                    <b>
                      Participants who choose BYPL options agree that all payments are
                      non-refundable and valid only as lifetime travel credit.
                    </b>
                  </li>
                </ul>
                <p>
                  3. <b>Recurring Payment Plan</b>
                </p>

                <ul className="default">
                  <li>
                    Participants who enroll in GIVE’s monthly payment plan may receive a discount
                    off the total program cost.
                  </li>
                  <li>
                    <b>
                      {' '}
                      All payments made through this option are non-refundable and valid only as
                      lifetime travel credit.
                    </b>
                  </li>
                </ul>
                <p>
                  4. <b>Standard Payment Plan</b>
                </p>

                <ul className="default">
                  <li>
                    Participants pay a <b>non-refundable deposit</b> to secure their spot and must
                    pay the remaining balance by the payment deadline.
                  </li>

                  <li>
                    {' '}
                    Remaining balance payments are eligible for <b>partial cash refunds</b>,
                    excluding any deposit(s), based on the cancellation timeline below. Participants
                    retain the option to convert any remaining funds into lifetime travel credit.
                  </li>
                </ul>

                <p>
                  Payments eligible for a lifetime travel credit are subject to the terms outlined
                  in the Travel Credit Policy below. Payments eligible for partial refunds are
                  subject to the terms outlined in the Cancellation Dates & Corresponding Fees
                  policy section below.
                </p>

                <h4>TRAVEL CREDIT POLICY</h4>
                <p>
                  {' '}
                  In cases where a Participant is unable to travel, GIVE may issue a non-refundable
                  travel credit in lieu of a refund, at its sole discretion and in accordance with
                  the below Terms. Travel credits are:
                </p>

                <ul className="default">
                  <li>Valid for life.</li>
                  <li>Issued in the name of the original Participant.</li>
                  <li>
                    Redeemable at a dollar-for-dollar value toward the base cost of any future GIVE
                    program.
                  </li>
                  <li>
                    Non-transferable to another person unless explicitly authorized by GIVE in
                    writing.
                  </li>
                  <li>
                    Subject to availability, program pricing, and GIVE’s offerings at the time of
                    redemption.
                  </li>
                  <li>
                    Travel credits do not accrue interest, do not constitute a trust or escrow, and
                    are only redeemable for eligible GIVE trips.
                  </li>
                </ul>

                <h4>
                  CANCELLATION NOTICE DATE &amp; CORRESPONDING FEES (STANDARD PAYMENT PLAN ONLY)
                </h4>
                <h5>Cancellation of trip by Participant:</h5>
                <p>
                  The Standard Payment Plan (above) allows for refundable options, less the trip
                  deposit and fees. All trip cancellations less than 80-days before the trip start
                  date incur a $150 late cancellation fee. This $150 late cancellation fee will be
                  deducted from the remaining balance of the canceled trip or reinstate the
                  non-refundable deposit(s) towards a future trip. The term “deposit(s)” below
                  includes any and all trip deposit(s) and add-on deposit(s). Participants will be
                  subject to the following terms based on the cancellation timeframe:
                </p>

                <ul className="default">
                  <li>
                    <b>80 days or more prior to departure:</b> All deposit(s) are non-refundable and
                    non-transferable, but good for life!
                  </li>
                  <li>
                    <b>79 to 70 days prior to departure:</b> Loss of 25% of the total program cost,
                    less nonrefundable deposit(s) and $150 fee.
                  </li>
                  <li>
                    <b>69 to 50 days prior to departure:</b> Loss of 50% of the total program cost,
                    less nonrefundable deposit(s) and $150 fee.
                  </li>
                  <li>
                    <b>49 to 31 days prior to departure:</b> Loss of 75% of the total program cost,
                    less nonrefundable deposit(s) and $150 fee
                  </li>
                  <li>
                    <b>30 days or less prior to departure:</b> Loss of 100% of total program cost,
                    including nonrefundable deposit(s).
                  </li>
                  <li>
                    <b>Failure to show up:</b> Loss of 100% of total program cost, including
                    non-refundable deposit(s)
                  </li>
                </ul>
                <p>Please note that the above cancellation policy does not include airfare.</p>
                <p>
                  Any cancellation eligible for cash refunds will be processed at the end of the
                  GIVE scheduled program term per the traveler’s request. There will be a $75
                  administrative fee to process refunds. If cancellation reasons are within the
                  terms of a Participant’s travel Trip Cancellation and Interruption Insurance
                  Policy, then the Participant must inform his/her insurance carrier and file a
                  claim for possible reimbursement.
                </p>
                <p>
                  <i>
                    See below for the policy and terms regarding trip transfers and if GIVE cancels
                    your trip due to Force Majeure.
                  </i>
                </p>
                <h4>TRIP TRANSFERS</h4>
                <h5>Transfer of trip by Participant:</h5>
                <p>
                  All payments convert to a nonrefundable travel credit once transferred. Trip
                  transfers are subject to the cancellation timetable listed above. The following
                  terms apply to trip transfers:
                </p>
                <ul className="default">
                  <li>
                    GIVE offers flexible trip transfers and payments convert to a nonrefundable
                    travel credit once transferred. All transfers are subject to availability and
                    the cancellation timetable listed above. Transfers less than 80 days prior to
                    the trip start date incur a $150 transfer fee.
                  </li>
                  <li>
                    Any trip payments not utilized within 2 years of the payment date convert to a
                    good-for-life travel credit to be utilized for any available GIVE trip location.
                  </li>
                </ul>
                <i>
                  See below for the policy and terms if GIVE cancels your trip due to Force Majeure
                </i>

                <h4>CANCELLATION DUE TO FORCE MAJEURE</h4>
                <h5>Cancellation or postponement of trip by GIVE</h5>
                <p>
                  GIVE will not be responsible for any trip delay, alteration, cancelation, or
                  failure to perform its obligations pursuant to these Terms if caused by Force
                  Majeure or forces of nature, foreseeable or unforeseeable events, or circumstances
                  beyond its reasonable control. Such circumstances include but are not limited to
                  acts of God, lightning strikes, earthquakes, floods, storms, explosions, fires and
                  any natural disaster; pandemics or epidemics; acts of war, protests, terrorism,
                  riots, civil commotion, malicious damage, sabotage and revolution; and strikes.
                </p>

                <h4>Third-Party Hosted Programs:</h4>

                <p>
                  For any program facilitated by GIVE that is hosted by a third-party organization,
                  the Deposit, Payment, Refund and Transfer Policy of the third party will supersede
                  the terms and conditions outlined in this document. Participants are required to
                  review and agree to the third party’s policies before completing their
                  registration. GIVE is not responsible for the enforcement or interpretation of the
                  third party’s policies and cannot offer exceptions, refunds, or accommodations
                  outside of what is stipulated by the hosting organization. By signing up for a
                  third-party-hosted program, participants acknowledge and accept these terms.
                </p>

                <h4>Private Trips:</h4>

                <p>
                  Private trips are governed by the terms and conditions mutually agreed upon by
                  GIVE and the designated representative of the private group.
                </p>

                <h3>Terms and Conditions</h3>
                <p>
                  (1) GIVE reserves the right to cancel the trip or any programs, activities, or
                  add-ons within the trip at any time for any reason. If that occurs you will be
                  notified. We reserve the right to decline to accept any applicant at our
                  discretion. You agree that your inability to participate in any trip program,
                  activity, or add-on, or the cancellation of any of the aforementioned, may be
                  beyond GIVE's control and that GIVE is not liable for any such decision by GIVE
                  trip leaders or Third Party Vendor.
                </p>
                <p>
                  (2) Except for add-ons operated by GIVE and are purchased in addition to the GIVE
                  trip, GIVE's obligation for the trip begins at Trip Commencement and ceases at
                  Trip End. The time and activities before Trip Commencement and after Trip End are
                  my sole responsibility and I agree to release GIVE from any and all responsibility
                  and liability. GIVE partners with Third Party Vendors who provide add-ons or other
                  services beyond the scope of GIVE's services and control, and you agree to release
                  GIVE from any and all responsibility and liability associated with such Add-ons or
                  services.
                </p>
                <p>
                  (3) You agree to follow the direction of the trip leaders and exercise reasonable
                  care in all activities in which you participate. You additionally understand and
                  agree that any deviation from planned activities, directions of the trip leaders,
                  GIVE rules, written or unwritten, or local laws and customs are your sole
                  responsibility and GIVE disclaims any and all responsibility and liability. You
                  understand that GIVE reserves the right to require you to withdraw at any time
                  during the trip without refund and at your expense if your participation impedes
                  the welfare, safety, or enjoyment of yourself, other participants, or GIVE. This
                  determination is made at the sole discretion of the trip leaders and is final on
                  all matters.
                </p>
                <p>
                  (4) You agree to follow GIVE's policies, local cultural considerations, and
                  participate in all activities and projects at the trip leaders' direction. Failure
                  to participate is means to require you to withdraw from the trip immediately
                  without refund and at your expense.
                </p>
                <p>
                  (5) You agree to follow all host country, city, and local laws and customs during
                  the trip's duration, including, but not limited to, illegal drug use and
                  under-aged consumption of alcohol. GIVE has zero-tolerance for criminal acts or
                  actions affecting the safety and well being of its volunteers and will exercise
                  its right to require you to withdraw from the trip without refund and at your
                  expense. This determination is made at the sole discretion of the trip leaders and
                  is final.
                </p>
                <p>
                  (6) You acknowledge and agree that you have carefully read, fully understand, and
                  agree to adhere to GIVE's policies and the contents of the{' '}
                  <a
                    href="https://www.givevolunteers.org/wp-content/uploads/give-safety-handbook.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    GIVE Volunteer Safety Handbook
                  </a>
                  ;
                </p>
                <p>
                  (7) You consent to the taking of photographic and video images and voice
                  recordings of you while participating in the trip by GIVE and its agents for their
                  commercial and promotional use.
                </p>
                <p>
                  (8) You acknowledge that you have voluntarily, fully, carefully, and truthfully
                  completed this Registration Form. You acknowledge that you were given the trip to
                  ask questions regarding the content of this form and therefore understand all the
                  questions, requests, and terms and conditions. You acknowledge that the
                  information on this form is for the safety of yourself, other trip participants,
                  and GIVE, and any and all incomplete or false information may hold you liable for
                  damages arising from such incomplete or false information and further releases
                  GIVE from any liability associated with such falsity or omission.
                </p>
                <p>
                  (9) This agreement will be interpreted, construed, and governed by and under
                  Washington State law, and you agree to unconditionally submit to the jurisdiction
                  of the Superior Court of Washington State in King County in all matters relating
                  to or arising from this agreement.
                </p>
                <br />

                <h2>ASSUMPTION OF RISK &amp; RELEASE OF LIABILITY AGREEMENT</h2>

                <h3>Express Assumption of Risks</h3>
                <p>
                  I voluntarily and knowingly agree to participate in this trip provided by GIVE. I
                  acknowledge that foreign countries, remote environments, outdoor settings,
                  volunteer work, and certain activities and sports may be hazardous and
                  unpredictable and while my trip leaders strive for safety, they are not
                  infallible. I am aware of the inherent risks and dangers involved, including but
                  not limited to:
                </p>
                <p>
                  (1) Motor vehicle, road, plane, boat, water transportation, and weather condition
                  hazards during transport to, from, and during the trip, including transport in
                  foreign countries, remote areas and outdoor settings;
                </p>
                <p>
                  (2) Accommodation hazards, including enclosed buildings such as hostels, hotels,
                  and private residences, and temporary shelters such as tents and improvised
                  shelters;
                </p>
                <p>
                  (3) Forces of nature, foreseen or unforeseen, including inclement weather and
                  temperatures, hazardous animals and plants, steep and treacherous terrain, bodies
                  of water, and other natural occurrences;
                </p>
                <p>
                  (4) Injuries and/or illnesses, physical and/or mental, permanent disability,
                  dismemberment, and death, caused by any foreseeable and/or unforeseeable factors;
                </p>
                <p>(5) Difficult or nonexistent means of communication;</p>
                <p>(6) Difficult or nonexistent evacuation, rescue, and/or medical treatment;</p>
                <p>(7) Unsafe or shortage of food and/or water;</p>
                <p>
                  (8) Affects of consuming alcoholic beverages and/or medications (prescription,
                  over the counter, herbal, and recreational);
                </p>
                <p>(9) Others in my group acting dangerously or in a manner putting me at risk;</p>
                <p>(10) My own actions putting me at risk;</p>
                <p>(11) Equipment loss and/or failure;</p>
                <p>(12) Activities and services provided by Third Party Vendors;</p>
                <p>
                  (13) The unpredictability of being in a foreign country, remote environments, and
                  outdoor settings including, but not limited to, changes in the political climate,
                  war, acts of terrorism, violence, and coups; and
                </p>
                <p>(14) Acts or omissions of GIVE or its trip leaders.</p>

                <p>
                  I acknowledge that the above list is only a fraction of possibilities of what may
                  occur during the trip, and that a full list would be impossible to ascertain. I
                  have reviewed the above and considered my own capabilities and limitations, this
                  trip, its remote and foreign location, the risks, the physical and mental demands,
                  and concluded that I am physically and emotionally fit and able to participate. In
                  spite of the inherent risks, I agree to be responsible for my own welfare and
                  accept any and all risks.
                </p>

                <h3>Release of Liability</h3>
                <p>
                  All reasonable effort has been made by GIVE to fully disclose the nature of this
                  trip to me. I have had the opportunity to ask any questions regarding this trip.
                  In consideration of the services furnished me, my legal representatives and I
                  release and discharge GIVE, its owners, officers, directors, agents, contractors,
                  Third Party Vendors, and employees from and against all liability which may arise
                  from my participation in this trip, including any claim for property loss, damage,
                  injury, or death that I may suffer, or any claims of negligence or omission. I
                  further agree to indemnify and hold harmless GIVE and members of the trip against
                  any sum I or GIVE may be subjected to pay in consequence of any claim or demand
                  made against me during my participation in this trip.
                </p>
                <p>
                  This agreement is intended to be interpreted as broadly as permissible under
                  Washington State law, and if any portion of this agreement is held invalid, it is
                  agreed that all other parts will continue in full legal force and effect.
                </p>
                <p>
                  This agreement will be interpreted, construed, and governed by and under
                  Washington State law, and any claim or controversy arising out of or relating to
                  this agreement will be settled by binding arbitration in King County, Washington.
                  Exclusive venue and jurisdiction over the parties and the subject matter to this
                  agreement will be in the Superior Court of Washington in King County for
                  commencing the arbitration proceedings and enforcing the arbitration award.
                </p>
                <p>
                  This agreement contains the final and complete agreement between GIVE and me with
                  respect to the subject matter herein, and there are no understandings,
                  representations, or warranties of any kind between us except as expressly set
                  forth herein. All prior agreements are placed within this one written agreement.
                </p>
                <p>
                  <b>
                    If you have any questions about this Assumption of Risk & Release of Liability
                    Agreement please contact us so that we may adequately answer them. By signing
                    below I understand and agree to the following:
                  </b>
                </p>
                <p>
                  <b>
                    (1) “Trip Commencement” means the date noted on my itinerary, or my later
                    arrival for any reason, whichever is later, and the time when I am introduced to
                    my GIVE guide;
                  </b>
                </p>
                <p>
                  <b>
                    (2) “Trip End” means the date noted on my itinerary, or my earlier departure for
                    any reason, whichever is earlier, and the conclusion of the GIVE trip with which
                    I am involved;
                  </b>
                </p>
                <p>
                  <b>
                    (3) “Add-on” means an excursion that I may choose to add onto and are beyond the
                    scope of the GIVE trip. Add-ons may be operated by GIVE or a Third Party Vendor;
                  </b>
                </p>
                <p>
                  <b>
                    (4) “Third Party Vendor” means a third-party provider of services that is an
                    independent contractor of GIVE's;
                  </b>
                </p>
                <p>
                  <b>
                    (5) Except for Add-ons operated by GIVE and are purchased in addition to the
                    GIVE trip, GIVE's obligation for the trip begins at Trip Commencement and ceases
                    at Trip End. The time and activities before Trip Commencement and after Trip End
                    are my sole responsibility and I agree to release GIVE from any and all
                    responsibility and liability. Add-ons provided by Third Party Vendors are beyond
                    the scope of GIVE's services and control, and I agree to release GIVE from any
                    and all responsibility and liability associated with such Add-ons;
                  </b>
                </p>
                <p>
                  <b>
                    (6) I have carefully read, fully understand, and agree to adhere to the contents
                    of the GIVE Volunteer Safety Handbook;
                  </b>
                </p>
                <p>
                  <b>
                    (7) I have received full disclosure and voluntarily and knowingly consent to
                    assume any and all risks, including those listed and agreed to herein and on the
                    Registration Form, and to release GIVE from any and all liability; and
                  </b>
                </p>
                <p>
                  <b>
                    (8) I have carefully read and fully understand the contents and legal
                    ramifications of this agreement. I understand this is a legally binding and
                    enforceable contract and sign it of my own free will.
                  </b>
                </p>
                <br />
                <div>
                  <p>
                    Disclaimer: By entering my name and clicking submit, I am confirming that I have
                    read and agree to the Terms and Conditions presented above.
                  </p>
                </div>
              </div>
              <div className="col-md-4 col-sm-12 center">
                <FieldControl
                  name="eSignature"
                  render={({ handler, touched, hasError, pristine }) => (
                    <div className="inputContainer center">
                      <input
                        id="eSignature"
                        className="form-control"
                        type="text"
                        value=""
                        {...handler()}
                      />
                      <label
                        htmlFor="eSignature"
                        className={`label ${
                          pristine && !registrationForm.controls.initials.value ? '' : 'notEmpty'
                        }`}
                      >
                        Full Name
                        <span className="error">{hasError('required') && ' - Required'}</span>
                      </label>
                    </div>
                  )}
                />
              </div>
              <div className="col-md-12 col-sm-12 center">
                <p>
                  <span id="form-error-message" className="error hidden">
                    Please complete all required fields.
                  </span>
                </p>
                <button type="submit">
                  Submit
                  <span id="submit-loading"></span>
                </button>
              </div>
            </form>
          </div>
        )}
      />
    </div>

    {/** {" "}
    <div className="resp-container">
      <iframe
        className="resp-iframe"
        title="terms-and-conditions"
        src={`https://givevolunteers.secure.force.com/pmtx/registrationForm?oid=${tripId}&cid=${userId}&dId=${documentId}`}
      />
    </div>
    <div>
      <p className="center">
        Please scroll down to the bottom and sign the document.
      </p>
    </div>
    <div className="right">
      <button onClick={checkDocumentsAccordionState}>
        I&apos;ve completed the agreement
      </button>
    </div>
     **/}
  </div>
);

TermsAndConditionsModal.propTypes = {
  handleRegistrationSubmit: PropTypes.func.isRequired,
  checkDocumentsAccordionState: PropTypes.func.isRequired,
  userId: PropTypes.string.isRequired,
  tripId: PropTypes.string.isRequired,
  destination: PropTypes.string.isRequired,
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
  documentId: PropTypes.string.isRequired,
  closeModal: PropTypes.func.isRequired,
};

export default TermsAndConditionsModal;
